// Components
import { RootState } from '../index';

const getVcatKitsData = (state: RootState) => state.vcatKitsDataSlice.vcat_kits;

export { getVcatKitsData };
